import React from 'react'
import type { Icon } from 'shared/utils'

const Facebook = (props: Icon) => {
    const { className = 'facebook', color = 'white', size = 24 } = props
    return (
        <svg width={size} height={size} fill={color} className={className}>
            <path
                d="M13.821 22v-9h2.733L17 9h-3.179V7.052c0-1.03.027-2.052 1.466-2.052h1.458V2.14c0-.043-1.253-.14-2.52-.14-2.645 0-4.302 1.657-4.302 4.7V9H7v4h2.923v9h3.898z"
                fillRule="evenodd"
            />
        </svg>
    )
}

export { Facebook }
